module.exports = __webpack_public_path__ + "static/img/ec102aea622b644d0b35cd929b7636de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youshi_wugan.png
// module id = QvU+
// module chunks = 1